<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :filtroOpcion="filtroOpcion"
          :fechaDesde="fechaDesdeParam"
          :fechaHasta="fechaHastaParam"
          :proveedor="proveedor"
          :numeroPresupuesto="numeroPresupuesto"
          :numeroOrdenProveedor="numeroOrdenProveedor"
          :sortByDescending="sortByDescending"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Compras">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="compras" 
              :fields="comprasFields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaComprobante)="data">
              {{ data.item.fechaComprobante | fecha }}
            </template>
            <template v-slot:cell(total)="data">
              {{ data.item.total | moneda(data.item.moneda) }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item 
                    @click.stop="creditoDebito(data.item)">
                  <i class="fa fa-plus"></i>Cancelar Comprobante (NCR/NDB)</b-dropdown-item>

                <!-- v-if="data.item.comprobanteTipoId == 1 || data.item.comprobanteTipoId == 9" -->
                <b-dropdown-item 
                    v-if="data.item.comprobanteTipoId == 1"
                    @click.stop="creditoParcial(data.item)">
                  <i class="fa fa-plus"></i>Generar NCR x Renglones</b-dropdown-item>

                <b-dropdown-item
                    v-if="opcionActualizarFechaImputacion" 
                    @click.stop="actualizarFechaImputacion(data.item)">
                  <i class="fa fa-edit"></i>Actualizar Fecha de Imputación</b-dropdown-item>

                <b-dropdown-item @click.stop="borrarItem(data.item)">
                  <i class="fa fa-remove"></i>Borrar Comprobante</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="agregarGasto">
            <i class="fa fa-plus"></i>Comprobante de Gastos</b-dropdown-item>
          <b-dropdown-item @click.stop="agregarCompra">
            <i class="fa fa-plus"></i>Comprobante de Compras</b-dropdown-item>
          <b-dropdown-item @click.stop="agregarCompraRemitos">
            <i class="fa fa-plus"></i>Comprobante de Facturación de Remitos</b-dropdown-item>
          <b-dropdown-item @click.stop="exportXls">
            <i class="fa fa-file-excel-o"></i>Exportar Listado de Comprobantes</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-modal ref="actualizacionFechaImputacion"
        title="Actualizar Fecha de Imputación"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-actualizacion-fecha-imputacion
        :compraId="compraId"
        @closeActualizacion="closeActualizacionFechaImputacion">
      </app-actualizacion-fecha-imputacion>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Filtro from './listFiltro.vue';
import ActualizacionFechaImputacion from './ActualizacionFechaImputacion.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import export_xls_compras from '../../mixins/export_xls_compras';
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'compras/getField',
  mutationType: 'compras/updateField',
});

export default {
  name: 'ComprasList',
  components: {
    appFiltro: Filtro,
    appActualizacionFechaImputacion: ActualizacionFechaImputacion,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal,
    export_xls_compras 
  ],
  data: () => {
    return {
      comprasFields: [
        {
          key: 'fechaComprobante',
          label: 'Fecha Comp.'
        },
        { key: 'proveedor' },
        { key: 'comprobante' },
        { key: 'numero' },
        // {
        //   key: 'moneda',
        // },
        {
          key: 'total',
          class: 'text-right'
        },
        // {
        //   key: 'montoTotal',
        //   class: 'text-right'
        // },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
      compraId: 0,
      opcionActualizarFechaImputacion: false
    }
  },
  computed: {
    ...mapFields([
      'compras',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'filtroOpcion',
      'fechaDesde',
      'fechaHasta',
      'proveedor',
      'numeroPresupuesto',
      'numeroOrdenProveedor',
      'sortByDescending'
    ]),
    fechaDesdeParam() {
      return moment(this.fechaDesde).format('YYYY-MM-DD');
    },
    fechaHastaParam() {
      return moment(this.fechaHasta).format('YYYY-MM-DD');
    }
  },
  created() {
    this.opcionActualizarFechaImputacion = Boolean(this.$store.getters['user/tieneAccesoModulo']('ComprasActualizarFechaImputacion'));    
    
    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.filtroOpcion = filtro.filtroOpcion;
      this.fechaDesde = filtro.fechaDesde;
      this.fechaHasta = filtro.fechaHasta;
      this.proveedor = filtro.proveedor;
      this.numeroOrdenProveedor = filtro.numeroOrdenProveedor;
      this.numeroPresupuesto = filtro.numeroPresupuesto;
      this.paginaActual = 1;
      
      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('compras/getCompras')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    agregarGasto () {
      this.$router.push({ name: 'CompraAdd' });

      // this.$router.push({ name: 'CompraABM', 
      //                     params: { 
      //                       id: 0,
      //                       ordenesProveedor: false
      //                     }
      //                   });
    },
    agregarCompra () {
      this.$router.push({ name: 'CompraOrdenesProveedoresAdd' });

      // this.$router.push({ name: 'CompraABM', 
      //                     params: { 
      //                       id: 0,
      //                       ordenesProveedor: true
      //                     }
      //                   });
    },
    agregarCompraRemitos () {
      this.$router.push({ name: 'CompraRemitosAdd' });

      // this.$router.push({ name: 'CompraABM', 
      //                     params: { 
      //                       id: 0,
      //                       remitos: true
      //                     }
      //                   });
    },
    consultar (item) {
      this.$router.push({ name: 'CompraData', 
                          params: { id: item.id }});
    },
    creditoDebito (item) {
      this.$router.push({ name: 'CompraCreditoDebito', 
                          params: { id: item.id }});
    },
    creditoParcial (item) {
      this.$router.push({ name: 'CompraCreditoParcial', 
                          params: { id: item.id }});
    },
    borrarItem (item) {
      this.showModalConfirm('¿Desea borrar el comprobante seleccionado?', 
            this.borrar.bind(this, item.id), 'Si', null, 'No')
    },
    borrar (compraId) {
      this.showSpinner();
      this.$store.dispatch('compras/delete', compraId)
        .then(() => this.showModalMsj('El comprobante se borró con éxito', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportXls () {
      let proveedorId = 0;
      if (this.proveedor) {
        if (this.proveedor.id) {
          proveedorId = this.proveedor.id;
        }
      }

      let params = {
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta,
        proveedorId
      }

      this.showSpinner();
      this.$store.dispatch('compras/getRptCompras', params)
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptCompras = this.$store.getters['compras/rptCompras'];

          if (rptCompras) {
            if (rptCompras.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            this.exportXLSRptCompras(rptCompras);
          } else {
            this.showModalMsj('No hay datos para exportar.', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    actualizarFechaImputacion (item) {
      this.compraId = item.id;
      this.$refs.actualizacionFechaImputacion.show();
    },
    closeActualizacionFechaImputacion() {
      this.$refs.actualizacionFechaImputacion.hide();
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
</style>
